export const SET_LOCALE = 'SET_LOCALE';

export const setLocale = (lng) => ({
  type: SET_LOCALE,
  payload: lng,
});
